// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vertical-divider[data-v-70879770] {\n  border-left: 1px solid #dedede;\n}\n.total-title[data-v-70879770] {\n  border: 1px solid #2db782;\n  color: #2db782;\n}\n.bg-money-green[data-v-70879770] {\n  background-color: #2db782;\n}", ""]);
// Exports
module.exports = exports;
